// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__gmH8a","social_list":"Footer_social_list__aoK20"};